module.exports = __webpack_public_path__ + "static/sport/h502.68034bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/h502.png
// module id = C/Vw
// module chunks = 0